<template>
    <div class="addTime">
        <el-dialog
            title="报价加时"
            :visible.sync="showAddTimeDialog"
            width="400px"
            :before-close="closeDialog">
             <el-form :model="timeForm" label-width="110px" ref="ruleForm" :rules="rules" class="wrapper-form">
            <!-- <span class="label">谈结束时间：</span>
            <el-date-picker
                v-model="timeForm.time"
                type="datetime"
                :picker-options="pickerOptionsStart"
                placeholder="选择洽谈结束时间">
            </el-date-picker> -->
                 <el-form-item class="item" label="恰谈结束时间：" prop="time">
                 <el-date-picker
                v-model="timeForm.time"
                type="datetime"
                :picker-options="pickerOptionsStart"
                placeholder="选择洽谈结束时间">
            </el-date-picker>
          </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" :loading="loadding" @click="confirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { addBidTime } from '../../../api/tenderDetails.js';
export default {
    name: 'add-time-dialog',
    data () {
        const time = (rule, value, callback) => {
            const date = new Date(this.form.effectDateFrom);// 获取开始时间戳
            const nowTime = date.getTime();
            var timestamp = new Date(value).getTime(); // 获取的结束时间戳
            if (!value) {
                callback(new Error('请输入洽谈结束时间'));
            } else if (timestamp - nowTime <= 0) {
                callback(new Error('不能小于开始时间'));
            } else { callback(); }
        };
        return {
            loadding: false,
            timeForm: {
                time: ''
            },
            pickerOptionsStart: { disabledDate: time => { return time.getTime() < new Date(new Date().toLocaleDateString()).getTime(); } },
            rules: {
                time: [{ required: true, validator: time, trigger: ['blur'] }]
            }
        };
    },
    props: {
        showAddTimeDialog: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        version: {
            type: Number,
            default: function() {
                return 0;
            }
        },
        id: {
            type: Number,
            default: function() {
                return 0;
            }
        },
        form: {
            type: Object,
            default: function() {
                return {};
            }
        }
    },
    components: {},
    methods: {
        closeDialog() {
            this.$emit('update:showAddTimeDialog', false);
        },
        confirm() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.getNDateTime();
                    const params = { version: this.version, effectDateTo: this.timeForm.time, id: this.id };
                    this.loadding = true;
                    addBidTime(params).then(res => {
                        this.loadding = false;
                        if (res && res.code === '0') {
                            this.$message.success('加时成功');
                            this.$emit('getData');
                            this.closeDialog();
                        }
                    });
                }
            });
        },
        getNDateTime() {
            const date = this.timeForm.time;
            const year = date.getFullYear();
            const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
            const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
            const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
            const second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            this.timeForm.time = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
        }
    },
    mounted() {
    }
};
</script>
<style lang="less">
.addTime {
    .label {
        font-size: 14px;
    }
    .el-form-item__error{width: 150px;}
}
</style>